import { render, staticRenderFns } from "./verified_articles_block.vue?vue&type=template&id=330e132a&lang=pug"
import script from "./verified_articles_block.vue?vue&type=script&lang=js"
export * from "./verified_articles_block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports